
import React from "react";
import Navigation from "@/components/Navigation";
import { motion } from "framer-motion";

const Team = () => {
  const teamMembers = [
    {
      name: "Nid",
      image: "/photos/nid.webp",
      description: "Nid to mistrzyni autentycznego tajskiego masażu, która połączyła tradycyjne techniki z intuicyjnym wyczuciem potrzeb klienta. Jej precyzyjny dotyk dociera do najgłębszych napięć, uwalniając je i przywracając energetyczną równowagę. Jeśli szukasz masażu, który nie tylko odpręży, ale również zregeneruje Twoje ciało i ducha, sesja z Nid będzie idealnym wyborem.",
    },
    {
      name: "Praew",
      image: "/photos/praew.webp",
      description: "Praew to doświadczona masażystka, która swoją pasję do masażu łączy z głęboką wiedzą o ciele. Jej terapeutyczny dotyk jest jednocześnie kojący i skuteczny - potrafi zlokalizować nawet najbardziej ukryte napięcia i uwolnić je z niezwykłą precyzją. Pou specjalizuje się w masażach, które nie tylko relaksują, ale również przywracają harmonię i energetyczną równowagę całemu organizmowi.",
    },
    {
      name: "Tui",
      image: "/photos/tui.webp",
      description: "Tui to ekspertka od uwalniania stresu i napięć poprzez harmonijne połączenie technik tajskiego masażu. Jej pewne dłonie potrafią odnaleźć źródła dyskomfortu i przekształcić je w uczucie lekkości i odprężenia. Tui podchodzi do każdego klienta indywidualnie, dostosowując intensywność i techniki do jego potrzeb. Po masażu wykonanym przez Tui poczujesz się odświeżony, zrelaksowany i pełen pozytywnej energii.",
    }
  ];

  return (
    <div className="bg-dark min-h-screen text-gold-light">
      <Navigation />
      
      <div className="pt-32 pb-16">
        <div className="container mx-auto px-4">
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-4xl font-bold text-center text-gold mb-16"
          >
            Nasz Zespół
          </motion.h1>

          <div className="space-y-24">
            {teamMembers.map((member, index) => (
              <motion.div
                key={member.name}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.2 }}
                className={`flex flex-col ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                } gap-8 items-center`}
              >
                <div className="w-full md:w-1/2">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-[500px] object-cover rounded-lg shadow-lg"
                    width="800"
                    height="500"
                  />
                </div>
                <div className="w-full md:w-1/2 space-y-4">
                  <h2 className="text-3xl font-semibold text-gold">{member.name}</h2>
                  <p className="text-lg leading-relaxed text-justify">{member.description}</p>
                  <button
                    onClick={() => window.open("https://booksy.com/pl-pl/139856_chaba-thai-massage_masaz_20103_slupsk#ba_s=sh_1", "_blank")}
                    className="bg-gold text-dark px-6 py-3 rounded-full hover:bg-gold-dark transition-colors"
                  >
                    Umów się na masaż
                  </button>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;
